import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionService } from '../services/session/session.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const session = inject(SessionService);

  const isValid = session.isSessionValid();
  if (isValid) {
    return true;
  } else {
  // Don't navigate imperatively here; return UrlTree so the router handles it cleanly.
  session.logout(false);
  return router.parseUrl('/login');
  }
};
